import axios from 'axios';
import api from './ApiAuthService';

export default class ContactService {

  static async getUsers(params: any = null) {
    try {
      let url = '/user';

      if (params) {
        url += '?';
      }

      if (params?.search) {
        url += '&search=' + params.search;
      }
  
      if (params?.country) {
        url += '&country=' + params.country.value;
      }
  
      if (params?.state) {
        url += '&state=' + params.state.value;
      }
  
      if (params?.city) {
        url += '&city=' + params.city.value;
      }

      if (params?.page) {
        url += '&page=' + params.page;
      }
  
      if (params?.per_page) {
        url += '&per_page=' + params.per_page;
      } else {
         if (params) {
          url += '&per_page=' + 30;
         } else {
          url += '?per_page=' + 30;
         }
      }

      // Se não tiver parâmetros, remove o '?' do final
      if (url === '/user') {
        url = url.replace('?', '');
      }

      const response = await api.get(url);
      // pegando paginação

      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  static async postMensagem(dados: any, url: '') {
    try {
      const response = await api.post(url, dados);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export async function getContactFilters(filters: any): Promise<any> {
  try {
    const response = await api.post('/posts/contact/filters', filters);
    return response;
    
  } catch (error) {
    console.error('Erro ao carregar a página', error);
    // throw new Error('Erro ao carregar a página');
  }
}